import React, { createContext, useContext, useEffect, useState } from "react";

type Lang = "th" | "en" | "my";

type LangContextType = {
  currentLang: Lang;
  translatedTexts: Record<string, string>;
  isTranslating: boolean;
  translateError: boolean;
  setLang: (lang: Lang) => void;
  t: (key: string) => string;
};

const LanguageContext = createContext<LangContextType | undefined>(undefined);

const baseTexts: Record<string, string> = {
  home: "หน้าหลัก",
  login: "เข้าสู่ระบบ",
  loginWelcome: "ยินดีต้อนรับสู่ Smart PRD Line",
  empCode: "รหัสพนักงาน",
  loginFailed: "โปรดตรวจสอบรหัสของคุณ",
  loginSuccess: "ขอต้อนรับคุณเข้าสู่ระบบ",
  confirm: "ยืนยัน",
  contactAdmin: "ติดต่อเจ้าหน้าที่",
  developed_by: "พัฒนาโดย",
  error: "เกิดข้อผิดพลาด",
  success: "สำเร็จ",
  welcome: "ยินดีต้อนรับ",
  profile: "โปรไฟล์",
  print_label: "พิมพ์ใบชี้บ่งผลิตภัณฑ์",
  order_scales: "รายการชั่งน้ำหนัก",
  detail: "รายละเอียด",
  weight_scales: "ชั่งน้ำหนัก",
  status_accept: "สถานะการรับของ",
  location: "สถานที่จัดเก็บ",
  scan_location: "สแกนสถานที่",
  status_location: "สถานะการจัดเก็บ",
  scan_label: "สแกนใบชี้บ่งผลิตภัณฑ์",
  no_data: "ไม่มีข้อมูล",
  employee_code: "รหัสพนักงาน",
  position: "ตำแหน่ง",
  department: "ฝ่าย",
  email: "อีเมล",
  nickname: "ชื่อเล่น",
  section: "แผนก",
  type: "ประเภท",
  logout: "ออกจากระบบ",
  confirmLogout: "คุณต้องการออกจากระบบหรือไม่?",
  cancel: "ยกเลิก",
  logoutSuccess: "ออกจากระบบสำเร็จ",
  order_print: "รายการพิมพ์",
  select_weight_point: "เลือกจุดชั่งน้ำหนัก",
  items: "รายการ",
  loading_data: "กำลังโหลดข้อมูล...",
  no_order: "ไม่มีรายการ",
  no_ordernow: "ไม่มีรายการที่ต้องทำในขณะนี้",
  back_to_home: "กลับไปที่หน้าหลัก",
  no_time: "ไม่มีเวลา",
  no_date: "ไม่มีวันที่",
  good: "งานดี",
  waste: "งานเสีย",
  urgent: "เร่งด่วน",
  position_order: "สถานที่",
  detail_order: "รายละเอียดเพิ่มเติม",
  name: "ชื่อ",
  order_number: "หมายเลขคำสั่งซื้อ",
  matcode: "รหัสวัสดุ",
  quantity: "จำนวน",
  container_number: "หมายเลขภาชนะ",
  employee_request: "ผู้ร้องขอ",
  date_time_request: "วันที่และเวลาที่ร้องขอ",
  accept_work: "รับงาน/ชั่งน้ำหนัก",
  message_error: "กรุณาลองใหม่อีกครั้ง",
  you_have_received_work_successfully: "คุณได้รับงานเรียบร้อยแล้ว",
  question_accept_work: "คุณต้องการรับงานนี้ใช่หรือไม่?",
  loading_send_data: "กำลังส่งข้อมูล...",
  requesting_camera_permission: "กำลังขอสิทธิ์การใช้งานกล้อง...",
  not_able_to_use_camera:
    "ไม่สามารถใช้งานกล้องได้ กรุณาเปิดสิทธิ์การใช้งานกล้อง",
  open_camera_permission: "เปิดสิทธิ์การใช้งานกล้อง",
  scan_qr_code: "สแกน QR Code",
  scan_qr_label: "สแกน Qr Code ป้ายชี้บ่งผลิตภัณฑ์",
  scan_qr_label_check_wip:
    "สแกน QR Code ที่ป้ายชี้บ่งผลิตภัณฑ์ที่ต้องการ Wip เท่านั้น",
  change_camera: "หมุนกล้อง",
  close_camera: "ปิดกล้อง",
  or: "หรือ",
  open_camera: "เปิดกล้อง",
  scan_success: "สแกนสำเร็จ",
  ok: "ตกลง",
  scan_failed: "สแกนไม่สำเร็จ",
  message_error_pull_data: "เกิดข้อผิดพลาดในการดึงข้อมูล",
  pull_weight_data: "ดึงข้อมูลน้ำหนัก",
  if_bunching_send_master:
    "หากเป็นเครื่อง Bunching จะต้องส่งข้อมูล Master ก่อนทุกครั้ง",
  pull_data_again: "ดึงข้อมูลอีกครั้ง",
  loading_pull_data: "กำลังดึงข้อมูล...",
  try_again: "กรุณาลองใหม่อีกครั้ง",
  cannot_send_data: "ไม่สามารถส่งข้อมูลได้",
  send_weight_master: "ส่งข้อมูลน้ำหนัก Master",
  send_weight: "ส่งข้อมูลน้ำหนัก",
  question_send: "ส่งข้อมูล?",
  question_send_data_weight: "คุณต้องการส่งข้อมูลนี้หรือไม่?",
  question_send_data_weight_master: "คุณต้องการส่งข้อมูล Master นี้หรือไม่?",
  send_data_weight_master_success: "ส่งข้อมูลน้ำหนัก Master สำเร็จ",
  send_data_weight_success: "ส่งข้อมูลน้ำหนักสำเร็จ",
  send_data_weight_failed: "ส่งข้อมูลน้ำหนักไม่สำเร็จ",
  loading_send_data_weight: "กำลังส่งข้อมูลน้ำหนัก...",
  successfully_received: "รับของเข้าระบบสำเร็จ",
  length: "ความยาว",
  date_time: "วันและเวลา",
  weight_point: "จุดชั่งน้ำหนัก",
  created_by: "จัดทำโดย",
  weight_measured: "น้ำหนักที่ชั่งได้",
  material_document: "Material Document",
  select_storage_location: "เลือกสถานที่จัดเก็บ",
  print_details: "รายละเอียดการพิมพ์",
  product_label_raw_material: "ป้ายชี้บ่งผลิตภัณฑ์/วัตถุดิบ",
  currently_typing: "กำลังพิมพ์...",
  confirm_print_label: "คุณต้องการพิมพ์ใบชี้บ่งผลิตภัณฑ์หรือไม่",
  data_saved_successfully: "บันทึกข้อมูลสำเร็จ",
  unable_to_save_data: "ไม่สามารถบันทึกข้อมูลได้",
  search_storage_location: "ค้นหาสถานที่จัดเก็บ",
  location_center: "สถานที่จัดเก็บส่วนกลาง",
  location_machine: "สถานที่จัดเก็บเครื่องจักร",
  location_details: "รายละเอียดสถานที่จัดเก็บ",
  location_name: "ชื่อสถานที่จัดเก็บ",
  plan: "แผนงาน",
  factory: "โรงงาน",
  storage_location: "สถานที่จัดเก็บ",
  machine: "เครื่องจักร",
  confirm_select_storage_location: "คุณต้องการเลือกสถานที่จัดเก็บนี้หรือไม่?",
  success_select_storage_location:
    "เลือกสถานที่จัดเก็บสำเร็จ",
  error_select_storage_location: "เกิดข้อผิดพลาดในการเลือกสถานที่จัดเก็บ",
  selected_location: "สถานที่จัดเก็บที่เลือก",
  please_scan_qr_code: "**โปรดสแกน QR Code ที่เลือก**",
  location_received: "สถานที่ที่รับของ",
  date_time_process: "วันและเวลาที่ดำเนินการ",
  operator: "ผู้ดำเนินการ",
  complete: "เสร็จสิ้น",
  print_tag_list: "รายการปริ้นป้ายแท็ก",
  search_order_number: "ค้นหาหมายเลขคำสั่งซื้อ",
  print: "พิมพ์",
  no_search_data: "ไม่พบข้อมูล",
  no_order_number: "ไม่มีหมายเลขคำสั่งซื้อ",
  search_print_tag_list: "ค้นหารายการปริ้นป้ายแท็ก",
  please_enter_order_number: "กรุณากรอกหมายเลขคำสั่งซื้อเพื่อค้นหา",
  wipsuccessfully_received: "Wip งานเข้าระบบสำเร็จ",
  back_to_list: "กลับไปหน้ารายการ",
  search_container_id: "ค้นหาหมายเลขภาชนะ",
  delete: "ลบ",
  weight_container: "น้ำหนักภาชนะ",
  weight_work: "น้ำหนักงาน",
  unable_to_load_image_or_font: "กำลังโหลดรูปภาพหรือแบบอักษร, โปรดรอสักครู่",
  print_error_occurred: "เกิดข้อผิดพลาดในการพิมพ์ กรุณาย้ายเข้าพื้นที่จากนั้นปัดแอปพลิเคชันแล้วลองใหม่",
  no_send_weight: "ยกเลิกการทำรายการ",
  question_cancel: "ยกเลิกการทำรายการ",
  question_cancel_send_data_weight: "คุณต้องการยกเลิกการทำรายการนี้หรือไม่?",
  cancel_send_data_weight_success: "ยกเลิกการทำรายการสำเร็จ",
  cancel_send_data_weight_failed: "ยกเลิกการทำรายการไม่สำเร็จ",
  wip: "WIP",
  customer_reel: "หมายเลขรีลลูกค้า (ถ้ามี)",
  customer_reel_placeholder: "กรุณาใส่หมายเลขรีลลูกค้า",
  changemeter : "แก้ไขจำนวน",
  please_change_quantity : "กรุณาเปลี่ยนจำนวน",
  enter_new_quantity : "กรุณาใส่จำนวนใหม่",
  you_have_changed_the_quantity_successfully : "คุณได้เปลี่ยนจำนวนเรียบร้อยแล้ว",
  please_enter_a_new_quantity : "กรุณาใส่จำนวนใหม่",
  warning: "คำเตือน",
  warning_no_customer_reel: "คุณไม่มีหมายเลขรีลลูกค้าใช่หรือไม่?",
  warning_check_customer_reel_before_send_weight: "ถ้ามีกรุณากรอกหมายเลขรีลลูกค้าก่อนส่งน้ำหนัก",
  ncr_work: "งานดี(NCR)",
};

const translations: Record<Lang, Record<string, string>> = {
  th: baseTexts,
  en: {
    home: "Home",
    login: "LOGIN",
    loginWelcome: "Welcome to Smart PRD Line",
    empCode: "Employee Code",
    loginFailed: "Please check your code",
    loginSuccess: "Welcome to the system",
    confirm: "Confirm",
    contactAdmin: "Contact Administrator",
    developed_by: "Developed by",
    error: "An error occurred",
    success: "Success",
    welcome: "Welcome",
    profile: "Profile",
    print_label: "Print Label",
    order_scales: "Order Scales",
    detail: "Detail",
    weight_scales: "Weight Scales",
    status_accept: "Status Accept",
    location: "Location",
    scan_location: "Scan Location",
    status_location: "Status Location",
    scan_label: "Scan Label",
    no_data: "No Data",
    employee_code: "Employee Code",
    position: "Position",
    department: "Department",
    email: "Email",
    nickname: "Nickname",
    section: "Section",
    type: "Type",
    logout: "Logout",
    confirmLogout: "Do you want to logout?",
    cancel: "Cancel",
    logoutSuccess: "Logout successfully",
    order_print: "Order Print",
    select_weight_point: "Select Weight Point",
    items: "Items",
    loading_data: "Loading data...",
    no_order: "No Order",
    no_ordernow: "No order now",
    back_to_home: "Back to Home",
    no_time: "No time",
    no_date: "No date",
    good: "Good Work",
    waste: "Waste Work",
    urgent: "Urgent",
    position_order: "Position",
    detail_order: "More Details",
    name: "Name",
    order_number: "Order Number",
    matcode: "Material Code",
    quantity: "Quantity",
    container_number: "Container Number",
    employee_request: "Requester",
    date_time_request: "Date and Time Requested",
    accept_work: "Accept Work/Weigh",
    message_error: "Please try again",
    you_have_received_work_successfully:
      "You have received the work successfully",
    question_accept_work: "Do you want to accept this work?",
    loading_send_data: "Loading send data...",
    requesting_camera_permission: "Requesting camera permission...",
    not_able_to_use_camera:
      "Unable to use camera. Please enable camera permission.",
    open_camera_permission: "Open camera permission",
    scan_qr_code: "Scan QR Code",
    scan_qr_label: "Scan QR Code Label",
    scan_qr_label_check_wip:
      "Scan QR Code on the label that needs to be WIP only",
    change_camera: "Change Camera",
    close_camera: "Close Camera",
    or: "or",
    open_camera: "Open Camera",
    scan_success: "Scan Success",
    ok: "OK",
    scan_failed: "Scan Failed",
    message_error_pull_data: "Error pulling data",
    pull_weight_data: "Pull Weight Data",
    if_bunching_send_master:
      "If it is a Bunching machine, you must send the Master data first every time",
    pull_data_again: "Pull data again",
    loading_pull_data: "Loading pull data...",
    try_again: "Please try again",
    cannot_send_data: "Cannot send data",
    send_weight_master: "Send Weight Master",
    send_weight: "Send Weight",
    question_send: "Send data?",
    question_send_data_weight: "Do you want to send this data?",
    question_send_data_weight_master: "Do you want to send this Master data?",
    send_data_weight_master_success: "Send Weight Master data successfully",
    send_data_weight_success: "Send Weight data successfully",
    send_data_weight_failed: "Send Weight data failed",
    loading_send_data_weight: "Loading send weight data...",
    successfully_received: "Successfully received the goods into the system",
    length: "Length",
    date_time: "Date and Time",
    weight_point: "Weight Point",
    created_by: "Created by",
    weight_measured: "Measured Weight",
    material_document: "Material Document",
    select_storage_location: "Select Storage Location",
    print_details: "Print Details",
    currently_typing: "Currently typing...",
    confirm_print_label: "Do you want to print the product label?",
    data_saved_successfully: "Data saved successfully",
    unable_to_save_data: "Unable to save data",
    search_storage_location: "Search Storage Location",
    location_center: "Location Center",
    location_machine: "Location Machine",
    product_label_raw_material: "Product Label / Raw Material",
    location_details: "Location Details",
    location_name: "Location Name",
    plan: "Plan",
    factory: "Factory",
    storage_location: "Storage Location",
    machine: "Machine",
    confirm_select_storage_location:
      "Do you want to select this storage location?",
      success_select_storage_location:
      "Select storage location successfully",
    error_select_storage_location:
      "Error selecting storage location",
    selected_location: "Selected Storage Location",
    please_scan_qr_code: "**Please scan the selected QR Code**",
    location_received: "Location Received",
    date_time_process: "Date and Time Process",
    operator: "Operator",
    complete: "Complete",
    print_tag_list: "Print Tag List",
    search_order_number: "Search Order Number",
    print: "Print",
    no_search_data: "No search data",
    no_order_number: "No order number",
    search_print_tag_list: "Search Print Tag List",
    please_enter_order_number: "Please enter order number to search",
    wipsuccessfully_received: "Wip work completed",
    back_to_list : "Back to list",
    search_container_id: "Search Container ID",
    delete: "Delete",
    weight_container: "Weight Container",
    weight_work: "Weight Work",
    unable_to_load_image_or_font: "Loading image or font, please wait...",
    print_error_occurred: "An error occurred while printing, please move to an area and swipe the application then try again",
    no_send_weight: "Cancel transaction",
    question_cancel: "Cancel transaction",
    question_cancel_send_data_weight: "Do you want to cancel this transaction?",
    cancel_send_data_weight_success: "Cancel transaction successfully",
    cancel_send_data_weight_failed: "Cancel transaction failed",
    wip: "WIP Work",
    customer_reel: "Customer Reel Number (if any)",
    customer_reel_placeholder: "Please enter customer reel number",
    changemeter : "Change Quantity",
    please_change_quantity : "Please change quantity",
    enter_new_quantity : "Please enter new quantity",
    you_have_changed_the_quantity_successfully : "You have changed the quantity successfully",
    please_enter_a_new_quantity : "Please enter a new quantity",
    warning: "Warning",
    warning_no_customer_reel: "You don't have a customer reel number, right?",
    warning_check_customer_reel_before_send_weight: "If any, please enter the customer reel number before sending weight",
    ncr_work: "Good Work (NCR)",
  },
  my: {
    home: "အိမ်",
    login: "လော့ဂ်အင်",
    loginWelcome: "Smart PRD Line ကိုကြိုဆိုပါတယ်",
    empCode: "ဝန်ထမ်းကုဒ်",
    loginFailed: "သင်၏ကုဒ်ကိုစစ်ဆေးပါ",
    loginSuccess: "စနစ်ထဲသို့ကြိုဆိုပါသည်",
    confirm: "အတည်ပြုရန်",
    contactAdmin: "အုပ်ချုပ်သူကို ဆက်သွယ်ပါ",
    developed_by: "ဖွံ့ဖြိုးတိုးတက်ရေးလုပ်ခဲ့သည်",
    error: "အမှားတစ်ခု ဖြစ်ပွားခဲ့သည်",
    success: "အောင်မြင်သည်",
    welcome: "ကြိုဆိုပါသည်",
    profile: "ပရိုဖိုင်",
    print_label: "အမှတ်တံဆိပ်ကို ပုံနှိပ်ပါ",
    order_scales: "အမိန့်အဆင့်များ",
    detail: "အသေးစိတ်",
    weight_scales: "အလေးချိန်အဆင့်များ",
    status_accept: "အခြေအနေ လက်ခံပါ",
    location: "တည်နေရာ",
    scan_location: "တည်နေရာကို စကန်ပါ",
    status_location: "တည်နေရာအခြေအနေ",
    scan_label: "အမှတ်တံဆိပ်ကို စကန်ပါ",
    no_data: "ဒေတာမရှိပါ",
    employee_code: "ဝန်ထမ်းကုဒ်",
    position: "ရာထူး",
    department: "ဌာန",
    email: "အီးမေးလ်",
    nickname: "နာမည်",
    section: "ဌာနခွဲ",
    type: "အမျိုးအစား",
    logout: "ထွက်ရန်",
    confirmLogout: "သင်ထွက်မလား?",
    cancel: "မလုပ်ပါ",
    logoutSuccess: "ထွက်ရန် အောင်မြင်သည်",
    order_print: "အမိန့်ပုံနှိပ်ပါ",
    select_weight_point: "အလေးချိန်အမှတ်ကို ရွေးပါ",
    items: "အမျိုးအစားများ",
    loading_data: "ဒေတာကို အားဖြည့်နေသည်...",
    no_order: "အမိန့်မရှိပါ",
    no_ordernow: "ယခုအခါမှာ အမိန့်မရှိပါ",
    back_to_home: "အိမ်ပြန်သွားပါ",
    no_time: "အချိန်မရှိပါ",
    no_date: "ရက်စွဲမရှိပါ",
    good: "အလုပ်ကောင်း",
    waste: "အလုပ်အဆိုး",
    urgent: "အရေးပေါ်",
    position_order: "အဆင့်အတန်း",
    detail_order: "အသေးစိတ်",
    name: "နာမည်",
    order_number: "အမိန့်နံပါတ်",
    matcode: "ပစ္စည်းကုဒ်",
    quantity: "အရေအတွက်",
    container_number: "အထုပ်နံပါတ်",
    employee_request: "တောင်းဆိုသူ",
    date_time_request: "တောင်းဆိုသည့် ရက်စွဲနှင့် အချိန်",
    accept_work: "အလုပ်လက်ခံပါ/အလေးချိန်",
    message_error: "ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ",
    you_have_received_work_successfully:
      "သင်သည် အလုပ်ကို အောင်မြင်စွာ လက်ခံရရှိခဲ့သည်",
    question_accept_work: "သင်သည် ဤအလုပ်ကို လက်ခံလိုပါသလား?",
    loading_send_data: "ဒေတာကို ပို့နေသည်...",
    requesting_camera_permission: "ကင်မရာခွင့်ပြုချက်ကို တောင်းဆိုနေသည်...",
    not_able_to_use_camera:
      "ကင်မရာကို အသုံးပြု၍ မရပါ။ ကင်မရာခွင့်ပြုချက်ကို ဖွင့်ပါ",
    open_camera_permission: "ကင်မရာခွင့်ပြုချက်ကို ဖွင့်ပါ",
    scan_qr_code: "QR ကုဒ်ကို စကန်ပါ",
    scan_qr_label: "အမှတ်တံဆိပ် QR ကုဒ်ကို စကန်ပါ",
    scan_qr_label_check_wip: "WIP လိုအပ်သော အမှတ်တံဆိပ် QR ကုဒ်ကိုသာ စကန်ပါ",
    change_camera: "ကင်မရာကို ပြောင်းပါ",
    close_camera: "ကင်မရာကို ပိတ်ပါ",
    or: "သို့မဟုတ်",
    open_camera: "ကင်မရာကို ဖွင့်ပါ",
    scan_success: "စကန်အောင်မြင်သည်",
    ok: "အိုကေ",
    scan_failed: "စကန်မအောင်မြင်ပါ",
    message_error_pull_data: "ဒေတာကို ဆွဲယူရာတွင် အမှားဖြစ်ပွားသည်",
    pull_weight_data: "အလေးချိန်ဒေတာကို ဆွဲယူပါ",
    if_bunching_send_master: "Bunching စက်ဖြစ်ပါက အမြဲတမ်း Master ကို ပို့ရမည်",
    pull_data_again: "ဒေတာကို ထပ်မံဆွဲယူပါ",
    loading_pull_data: "ဒေတာကို ဆွဲယူနေသည်...",
    try_again: "ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ",
    cannot_send_data: "ဒေတာကို ပို့၍ မရပါ",
    send_weight_master: "အလေးချိန် Master ကို ပို့ပါ",
    send_weight: "အလေးချိန်ကို ပို့ပါ",
    question_send: "ဒေတာကို ပို့မလား?",
    question_send_data_weight: "သင်သည် ဤဒေတာကို ပို့လိုပါသလား?",
    question_send_data_weight_master: "သင်သည် ဤ Master ဒေတာကို ပို့လိုပါသလား?",
    send_data_weight_master_success:
      "အလေးချိန် Master ဒေတာကို အောင်မြင်စွာ ပို့သည်",
    send_data_weight_success: "အလေးချိန်ဒေတာကို အောင်မြင်စွာ ပို့သည်",
    send_data_weight_failed: "အလေးချိန်ဒေတာကို ပို့၍ မရပါ",
    loading_send_data_weight: "အလေးချိန်ဒေတာကို ပို့နေသည်...",
    successfully_received: "အလုပ်ကို အောင်မြင်စွာ လက်ခံရရှိသည်",
    length: "အရှည်",
    date_time: "ရက်စွဲနှင့် အချိန်",
    weight_point: "အလေးချိန် အမှတ်",
    created_by: "ဖန်တီးသူ",
    weight_measured: "အလေးချိန်ကို တိုင်းတာသည်",
    material_document: "ပစ္စည်းစာရွက်",
    select_storage_location: "သိုလှောင်ရန် တည်နေရာကို ရွေးပါ",
    print_details: "ပုံနှိပ်ရန် အသေးစိတ်",
    currently_typing: "လက်ရှိ အထွေထွေ စာရိုက်နေသည်...",
    confirm_print_label: "ထုတ်ကုန်အမှတ်တံဆိပ်ကို ပုံနှိပ်လိုပါသလား",
    data_saved_successfully: "ဒေတာကို အောင်မြင်စွာ သိမ်းဆည်းသည်",
    unable_to_save_data: "ဒေတာကို သိမ်းဆည်း၍ မရပါ",
    search_storage_location: "သိုလှောင်ရန် တည်နေရာကို ရှာပါ",
    location_center: "သိုလှောင်ရန် တည်နေရာ အလယ်ဗဟို",
    location_machine: "သိုလှောင်ရန် တည်နေရာ စက်",
    product_label_raw_material: "ထုတ်ကုန်အမှတ်တံဆိပ်/မူလပစ္စည်း",
    location_details: "သိုလှောင်ရန် တည်နေရာ အသေးစိတ်",
    location_name: "သိုလှောင်ရန် တည်နေရာ အမည်",
    plan: "အစီအစဉ်",
    factory: "စက်ရုံ",
    storage_location: "သိုလှောင်ရန် တည်နေရာ",
    machine: "စက်",
    confirm_select_storage_location:
      "သင်သည် ဤသိုလှောင်ရန် တည်နေရာကို ရွေးချယ်လိုပါသလား?",
    success_select_storage_location:
      "သိုလှောင်ရန် တည်နေရာကို အောင်မြင်စွာ ရွေးချယ်သည်",
    error_select_storage_location:
      "သိုလှောင်ရန် တည်နေရာကို ရွေးချယ်ရာတွင် အမှားဖြစ်ပွားသည်",
    selected_location: "ရွေးချယ်ထားသော သိုလှောင်ရန် တည်နေရာ",
    please_scan_qr_code: "**ရွေးချယ်ထားသော QR ကုဒ်ကို စကန်ပါ**",
    location_received: "လက်ခံထားသော တည်နေရာ",
    date_time_process: "လုပ်ငန်းစဉ် ရက်စွဲနှင့် အချိန်",
    operator: "အလုပ်သမား",
    complete: "ပြီးပြီ",
    print_tag_list: "အမှတ်တံဆိပ်စာရင်းကို ပုံနှိပ်ပါ",
    search_order_number: "အမိန့်နံပါတ်ကို ရှာပါ",
    print: "ပုံနှိပ်ပါ",
    no_search_data: "ရှာဖွေရန် ဒေတာမရှိပါ",
    no_order_number: "အမိန့်နံပါတ်မရှိပါ",
    search_print_tag_list: "အမှတ်တံဆိပ်စာရင်းကို ရှာပါ",
    please_enter_order_number: "ရှာဖွေရန် အမိန့်နံပါတ်ကို ရိုက်ထည့်ပါ",
    wipsuccessfully_received: "Wip အလုပ်ကို အောင်မြင်စွာ လက်ခံရရှိသည်",
    back_to_list: "စာရင်းသို့ ပြန်သွားပါ",
    search_container_id: "အထုပ် ID ကို ရှာပါ",
    delete: "ဖျက်ပါ",
    weight_container: "အထုပ်အလေးချိန်",
    weight_work: "အလုပ်အလေးချိန်",
    unable_to_load_image_or_font: "ပုံနှိပ်သို့မဟုတ် အက္ခရာကို အားဖြည့်နေသည်၊ ကျေးဇူးပြု၍ စောင့်ပါ",
    print_error_occurred: "ပုံနှိပ်ရာတွင် အမှားတစ်ခု ဖြစ်ပွားခဲ့သည်၊ ကျေးဇူးပြု၍ နေရာကို ပြောင်းပြီး အက်ပ်ကို ဆွဲပါ",
    no_send_weight: "လုပ်ငန်းကို ပယ်ဖျက်ပါ",
    question_cancel: "လုပ်ငန်းကို ပယ်ဖျက်မလား",
    question_cancel_send_data_weight: "သင်သည် ဤလုပ်ငန်းကို ပယ်ဖျက်လိုပါသလား?",
    cancel_send_data_weight_success: "လုပ်ငန်းကို အောင်မြင်စွာ ပယ်ဖျက်သည်",
    cancel_send_data_weight_failed: "လုပ်ငန်းကို ပယ်ဖျက်၍ မရပါ",
    wip: "WIP အလုပ်",
    customer_reel: "ဖောက်သည် Reel နံပါတ် (ရှိပါက)",
    customer_reel_placeholder: "ဖောက်သည် reel နံပါတ်ကို ရိုက်ထည့်ပါ",
    changemeter : "အရေအတွက်ကို ပြောင်းပါ",
    please_change_quantity : "အရေအတွက်ကို ပြောင်းပါ",
    enter_new_quantity : "အရေအတွက်အသစ်ကို ရိုက်ထည့်ပါ",
    you_have_changed_the_quantity_successfully : "သင်သည် အရေအတွက်ကို အောင်မြင်စွာ ပြောင်းလဲခဲ့သည်",
    please_enter_a_new_quantity : "အရေအတွက်အသစ်ကို ရိုက်ထည့်ပါ",
    warning: "သတိပေးချက်",
    warning_no_customer_reel: "သင်တွင် ဖောက်သည် reel နံပါတ် မရှိပါ၊ မှန်ပါသလား?",
    warning_check_customer_reel_before_send_weight: "ရှိပါက အလေးချိန်ပို့မည့်အရင် ဖောက်သည် reel နံပါတ်ကို ရိုက်ထည့်ပါ",
    ncr_work: "အလုပ်ကောင်း (NCR)",
  },
};

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentLang, setCurrentLang] = useState<Lang>("th");
  const [translatedTexts, setTranslatedTexts] = useState<
    Record<string, string>
  >(translations["th"]);

  const [isTranslating] = useState(false); // not used anymore
  const [translateError] = useState(false); // not used anymore

  const setLang = (lang: Lang) => {
    if (lang === currentLang) return;
    setCurrentLang(lang);
    setTranslatedTexts(translations[lang] || baseTexts);
  };

  const t = (key: string): string => {
    return translatedTexts[key] || key;
  };

  useEffect(() => {
    setTranslatedTexts(translations[currentLang] || baseTexts);
  }, [currentLang]);

  return (
    <LanguageContext.Provider
      value={{
        currentLang,
        translatedTexts,
        isTranslating,
        translateError,
        setLang,
        t,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context)
    throw new Error("useLanguage must be used within LanguageProvider");
  return context;
};

export default LanguageProvider;
